/**
 * **plain テーマ**（Issue #523）。**文字と線だけ**の素の舞台。
 *
 * 2 つ目のテーマとして、`core/theme` / `core/hud` の契約が本当に実装を分離できているかの**検算**を兼ねる:
 *
 * - 盤は `video` / `lines` / `cards` の 3 層だけ（**マットの地と枠線を持たない**）
 * - カードは画像を貼らず**名前の文字**
 * - HUD は**枠を持たない**（`plate` を答えない → `core/hud` が null を入れる）
 * - 盤の写り（`view`）を見ない
 */
import { toHud } from '../../core/hud';
import { toTheme } from '../../core/theme';
import field from './drawField';
import objects from './drawObjects';
import PlainHud, { HUD_PARTS, HUD_SCHEMA, HUD_STYLE, anchors } from './drawHud';

export default toTheme({
  name: 'plain',
  label: '素（文字だけ）',
  field,
  objects,
  schema: HUD_SCHEMA,
  style: HUD_STYLE,
  /** 縁取りを名乗る部品（宣言と既定値は `core/decor` ＋ 上の `style`。Issue #523） */
  parts: HUD_PARTS,
  hud: toHud({
    anchors,
    Component: PlainHud,
    options: {
      /** 手札の枚数の行を出す */
      showHand: true,
    },
  }),
  options: {
    /** ゾーンの枠にキーの文字を出す（`lines` の層） */
    zoneLabels: false,
  },
});
